import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.ComponentProps<'input'> {
  icon?: React.ReactNode;
  label?: React.ReactNode;
  error?: React.ReactNode;
  wrapperClassName?: string;
  className?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, wrapperClassName, label, error, icon, type, ...props },
    ref,
  ) => {
    return (
      <div className={cn('flex flex-col gap-[10px]', wrapperClassName)}>
        {label}
        <div
          className={cn(
            'flex h-[50px] flex-row items-center justify-center rounded-[8px] border border-[#6b6b6b]',
          )}
        >
          {icon}
          <input
            type={type}
            className={cn(
              'file:text-foreground placeholder:text-secondary-light-gray text-secondary-white-vei flex h-full w-full bg-transparent px-3 py-1 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
              className,
            )}
            ref={ref}
            {...props}
          />
        </div>
        {error && <div className="text-red-500">{error}</div>}
      </div>
    );
  },
);

Input.displayName = 'Input';

export { Input };
